import LinkCard from "components/shared/card";
import { sidebarData } from "data";
import React from "react";
import { Row } from "react-bootstrap";

const Dashboard = () => {
    const topCards = sidebarData.map((topcard, index) => {
        if (topcard.text === "dashboard") return "";
        return <LinkCard cardData={topcard} key={index} />;
    });
    return (
        <div className="topCards">
            <Row className="gy-4">{topCards}</Row>
        </div>
    );
};

export default Dashboard;
